import { Injectable, InjectionToken } from '@angular/core';

/**
 * Opciones para personalizar mensajes de feedback
 */
export interface AlertOptions {
  /** Duración del mensaje en milisegundos */
  duration?: number;
  /** Texto del botón de acción (si aplica) */
  action?: string;
  /** Posición horizontal del mensaje */
  horizontalPosition?: 'start' | 'center' | 'end';
  /** Posición vertical del mensaje */
  verticalPosition?: 'top' | 'bottom';
  /** Clases CSS adicionales */
  panelClass?: string[];

  /** Datos adicionales específicos de la implementación */
  [key: string]: unknown;
}

export type FeedbackType = 'success' | 'error' | 'info' | 'warning';

@Injectable()
export abstract class AlertService {
  /**
   * Muestra un mensaje de feedback al usuario
   * @param message Mensaje a mostrar
   * @param options Opciones de configuración
   */
  abstract show(message: string, options?: AlertOptions): void;

  /**
   * Muestra un mensaje de éxito
   * @param message Mensaje a mostrar
   * @param options Opciones de configuración
   */
  abstract showSuccess(message: string, options?: AlertOptions): void;

  /**
   * Muestra un mensaje de error
   * @param message Mensaje a mostrar
   * @param options Opciones de configuración
   */
  abstract showError(message: string, options?: AlertOptions): void;

  /**
   * Muestra un mensaje de información
   * @param message Mensaje a mostrar
   * @param options Opciones de configuración
   */
  abstract showInfo(message: string, options?: AlertOptions): void;

  /**
   * Muestra un mensaje de advertencia
   * @param message Mensaje a mostrar
   * @param options Opciones de configuración
   */
  abstract showWarning(message: string, options?: AlertOptions): void;
}

/**
 * Token de inyección para el servicio de feedback
 */
export const FEEDBACK_SERVICE = new InjectionToken<AlertService>(
  'FEEDBACK_SERVICE',
);
